import { createContext, useContext, useEffect, useState } from "react";
import {
  getLoggedInUser,
  logout as logoutService,
} from "../services/auth.service";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const loadUser = async () => {
    setLoading(true);
    try {
      const userData = await getLoggedInUser();
      if (userData.success || userData.sucess) {
        setUser(userData.user);
        return userData.user;
      } else {
        setUser(null);
      }
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }

    return null;
  };
  useEffect(() => {
    loadUser();
  }, []);

  const hasPermission = (permission) => {
    return user?.permissions?.includes(permission);
  };

  const logout = async () => {
    setIsLoggingOut(true);
    try {
      await logoutService();
      setUser(null);
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isLoggedIn: !!user,
        isLoggingOut,
        isAdmin: user?.role === "admin",
        hasPermission,
        logout,
        loadUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
